<template>

</template>
<script>
    import baseUrl from '../config'; // 这里设置了一个文件作为所有请求的基础ip地址
    //语音AI
    import {Any} from 'google-protobuf/google/protobuf/any_pb';
    import {
        AudioChunkContent,
        AudioFormatContent,
        AudioSpeechRecognitionResultContent,
        RealTimeChatMessage,
        RealTimeChatMessageOperationType,
        RealTimeChatMessageType,
    } from '../assets/js/generated/RealTimeChatService_pb'
    // import { RealTimeChatServiceClient } from './generated/RealTimeChatServiceServiceClientPb.ts';
    import * as pcm from '../assets/js/utils/pcm_utils.ts';

    export default {
        name: 'Home',
        data() {
            return {
                audioUrl: '',//ai语音流
                audioType:false,//语音是否播放完

                AIimgType:true,//ai人物是否显示
                //人物动画
                imgUrl:this.$imgJson.taskAiImgArr[0],
                timer:null,//定时器,

                //AI.json
                ws: null,////实现WebSocket
                record: null, //多媒体对象，用来处理音频
                command: null,//最新语音汉字
                lastCommandUpdate: null,//最新语音汉字的时间
                triggerAiDate: null,//触发ai语语音的时间
                askNum: 0,//询问次数 大于三次自动退出语音助手
                numOfAudioPacketsSent: 0,
                audioFormat: 'N/A',
                audioFormatRtcProto: null,
                targetPcmFormat: {
                    channels: 1,
                    sampleRate: 16000,
                    bitDepth: 16,
                },
            }
        },
        mounted() {

            this.info();//初始调用语音监听
        },
        methods: {

            //AI语音功能
            init(rec) {
                this.record = rec;
            },
            handleSrResult(content) {
                const isIntermediate = content.getIsintermediate();
                const srResult = content.getText().trim();
                if (!isIntermediate) {
                    console.log(`srResult: (${isIntermediate}) ${srResult}`);
                    this.command = srResult+'_'+new Date().getTime();
                    this.lastCommandUpdate = new Date();
                    console.log('开始向app发送数据')
                }
            },
            reconnectedIfNeeded() {
                if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) {
                    return;
                }
                try {
                    this.ws?.close();
                } catch (e) {
                    console.error(e);
                }
                this.ws = new WebSocket(baseUrl.DOMAIN_NAME.AI_URL+"/rtc");
                this.bindWebSocketEventListeners()
            },
            bindWebSocketEventListeners() {
                if (this.ws) {
                    this.ws.onmessage = this.webSocketOnMessage;
                    this.ws.onopen = this.webSocketOnOpen;
                    this.ws.onerror = this.webSocketOnError;
                    this.ws.onclose = this.webSocketOnClose;
                }
            },
            webSocketOnMessage(evt) {
                const blob = evt.data;
                const fileReader = new FileReader();
                // console.log(blob)
                fileReader.readAsArrayBuffer(blob);
                fileReader.onload = () => {
                    const message = RealTimeChatMessage.deserializeBinary(new Uint8Array(fileReader.result));
                    // console.log(message.getType());
                    if (message.getType() === RealTimeChatMessageType.AUDIORESPONSE) {
                        // console.log(message.getContent());
                        // const content = message
                        //     .getContent()
                        //     .unpack(
                        //         AudioResponseContent.deserializeBinary,
                        //         'RealTimeChat.AudioResponseContent',
                        //     ) as AudioResponseContent;

                        // const text = content.getText();
                        // console.log(`text: ${text}`);
                        // self.audioPlayUrl = content.getAudiourl();
                        // console.log(self.audioPlayUrl);
                        // const audioTag = document.getElementById('audio_player') as HTMLAudioElement;
                        // audioTag.play();
                    } else if (message.getType() === RealTimeChatMessageType.AUDIOSPEECHRECOGNITIONRESULT) {
                        const content = message
                            .getContent()
                            .unpack(
                                AudioSpeechRecognitionResultContent.deserializeBinary,
                                'RealTimeChat.AudioSpeechRecognitionResultContent',
                            );
                        // console.log(content)
                        this.handleSrResult(content);
                    } else if (message.getType() === RealTimeChatMessageType.INTERRUPSIGNAL) {
                        // self.audioPlayUrl = '';
                    }
                };
            },
            webSocketOnOpen() {
                this.useWebSocket(this.audioFormatRtcProto);
                console.log('audio format sent');
                // console.log(this.audioFormatRtcProto);
            },
            webSocketOnError(){
                console.log('error');
            },
            webSocketOnClose(){
                if(this.$route.name=='Home'){
                    console.log('close');

                }
            },
            useWebSocket(message) {
                // ws = new WebSocket("wss://10.0.0.10/wsapi/rtc");
                // ws.binaryType = 'arraybuffer'; //传输的是 ArrayBuffer 类型的数据
                this.reconnectedIfNeeded();
                // console.log(WebSocket.OPEN)
                // console.log(ws.readyState)
                if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                    // console.log(message.serializeBinary().buffer)
                    this.ws.send(message.serializeBinary().buffer);
                }
            },
            //初始化调用ai
            info() {
                navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
                if (!navigator.getUserMedia) {
                    alert('浏览器不支持音频输入');
                } else {
                    navigator.getUserMedia({
                            audio: true
                        },
                        (stream) => {
                            // console.log(mediaStream)
                            let that = this;
                            var Recorder = function (stream) {
                                var sampleBits = 16; //输出采样数位 8, 16
                                var sampleRate = 48000; //输出采样率
                                var context = new AudioContext();
                                var audioInput = context.createMediaStreamSource(stream);
                                var recorder = context.createScriptProcessor(4096, 1, 1);
                                var audioData = {
                                    size: 0, //录音文件长度
                                    buffer: [], //录音缓存
                                    inputSampleRate: 16000, //输入采样率
                                    inputSampleBits: 16, //输入采样数位 8, 16
                                    outputSampleRate: sampleRate, //输出采样数位
                                    oututSampleBits: sampleBits, //输出采样率
                                    clear: function () {
                                        this.buffer = [];
                                        this.size = 0;
                                    },
                                    input: function (data) {
                                        this.buffer.push(new Float32Array(data));
                                        this.size += data.length;
                                    },
                                    compress: function () { //合并压缩
                                        //合并
                                        var data = new Float32Array(this.size);
                                        var offset = 0;
                                        for (var i = 0; i < this.buffer.length; i++) {
                                            data.set(this.buffer[i], offset);
                                            offset += this.buffer[i].length;
                                        }
                                        //压缩
                                        var compression = parseInt(this.inputSampleRate / this.outputSampleRate);
                                        var length = data.length / compression;
                                        var result = new Float32Array(length);
                                        var index = 0,
                                            j = 0;
                                        while (index < length) {
                                            result[index] = data[j];
                                            j += compression;
                                            index++;
                                        }
                                        return result;
                                    },
                                    encodePCM: function () { //这里不对采集到的数据进行其他格式处理，如有需要均交给服务器端处理。
                                        var sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate);
                                        var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
                                        var bytes = this.compress();
                                        var dataLength = bytes.length * (sampleBits / 8);
                                        var buffer = new ArrayBuffer(dataLength);
                                        var data = new DataView(buffer);
                                        var offset = 0;
                                        for (var i = 0; i < bytes.length; i++, offset += 2) {
                                            var s = Math.max(-1, Math.min(1, bytes[i]));
                                            data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
                                        }
                                        return new Blob([data]);
                                    }
                                };

                                var sendData = (message) => { //对以获取的数据进行处理(分包)

                                    if (message != null) {
                                        that.useWebSocket(message);
                                    }
                                    audioData.clear();//每次发送完成则清理掉旧数据
                                };

                                this.start = () => {
                                    audioInput.connect(recorder);
                                    recorder.connect(context.destination);
                                }

                                this.stop = () => {
                                    recorder.disconnect();
                                }

                                this.getBlob = () => {
                                    return audioData.encodePCM();
                                }

                                var clear = () => {
                                    audioData.clear();
                                }

                                recorder.onaudioprocess = function (e) {
                                    // var inputBuffer = e.inputBuffer.getChannelData(0);
                                    var inputBuffer = e.inputBuffer;
                                    if (!that.audioFormatRtcProto) {
                                        const rawAudioFormat = {
                                            float: true,
                                            channels: inputBuffer.numberOfChannels,
                                            sampleRate: inputBuffer.sampleRate,
                                            interleaved: false,
                                            bitDepth: inputBuffer.bitDepth,
                                        };
                                        that.audioFormat = JSON.stringify(rawAudioFormat);
                                        const audioFormatProto = new AudioFormatContent();
                                        audioFormatProto.setChannels(rawAudioFormat.channels);
                                        audioFormatProto.setBitdepth(rawAudioFormat.bitDepth);
                                        audioFormatProto.setSamplerate(rawAudioFormat.sampleRate);
                                        // console.log(audioFormatProto);

                                        const messageProto = new RealTimeChatMessage();
                                        messageProto.setType(RealTimeChatMessageType.AUDIOFORMAT);
                                        messageProto.setOperationtype(RealTimeChatMessageOperationType.INFORM);
                                        const content = new Any();
                                        content.pack(audioFormatProto.serializeBinary(), 'RealTimeChat.AudioFormatContent');
                                        messageProto.setContent(content);

                                        // console.log(messageProto);
                                        that.audioFormatRtcProto = messageProto;
                                    }
                                    const resampled = pcm.toArrayBuffer(inputBuffer, that.targetPcmFormat);
                                    const audioChunkProto = new AudioChunkContent();
                                    audioChunkProto.setData(new Uint8Array(resampled));
                                    const messageProto = new RealTimeChatMessage();
                                    messageProto.setType(RealTimeChatMessageType.AUDIOCHUNK);
                                    messageProto.setOperationtype(RealTimeChatMessageOperationType.INFORM);
                                    const content = new Any();
                                    content.pack(audioChunkProto.serializeBinary(), 'RealTimeChat.AudioChunkContent');
                                    messageProto.setContent(content);
                                    // console.log(messageProto)
                                    that.numOfAudioPacketsSent += 1;
                                    audioData.input(inputBuffer);
                                    sendData(messageProto);
                                }
                            }
                            that.init(new Recorder(stream));
                            console.log('开始对讲');
                            // console.log(that.record)
                            that.record.start();
                        },
                        function (error) {
                            console.log(error);
                            switch (error.message || error.name) {
                                case 'PERMISSION_DENIED':
                                case 'PermissionDeniedError':
                                    console.info('用户拒绝提供信息。');
                                    break;
                                case 'NOT_SUPPORTED_ERROR':
                                case 'NotSupportedError':
                                    console.info('浏览器不支持硬件设备。');
                                    break;
                                case 'MANDATORY_UNSATISFIED_ERROR':
                                case 'MandatoryUnsatisfiedError':
                                    console.info('无法发现指定的硬件设备。');
                                    break;
                                default:
                                    console.info('无法打开麦克风。异常信息:' + (error.code || error.name));
                                    break;
                            }
                        }
                    )
                }
            },
            //关闭连接
            closeAi() {
                this.ws ? this.ws.close() : '';
                this.record ? this.record.stop() : '';
            },
        },
    }
</script>

